import axios from './interceptor'
import { baseUrl } from './config'
import { flatten } from 'lodash'
import moment from 'moment'
import { DEFAULT_RETRY_TIMES } from '../../constants/app'

export default {
  async list (merchantId, takeaway, datetime) {
    const data = await axios.get(`${baseUrl}/c/category`, {
      params: {
        merchantID: merchantId,
        ...datetime && { time: moment(datetime).format() },
      },
      retry: DEFAULT_RETRY_TIMES,
    }).then(async res => {
      let categories = res.data
      const categoryIDs = flatten(categories.map(category =>
        category.categories.length
          ? category.categories.map(c => c.id)
          : category.id,
      ))
      const [nonEmptyMenuCategoryIds, nonEmptySetMenuCategoryIds] = await Promise.all([
        axios.get(`${baseUrl}/c/menu/category?${categoryIDs.map(id => `categoryIDs=${id}`).join('&')}`, {
          params: {
            merchantID: merchantId,
            takeaway,
          },
          retry: DEFAULT_RETRY_TIMES,
        }).then(res => res.data),
        axios.get(`${baseUrl}/c/setmenu/category?${categoryIDs.map(id => `categoryIDs=${id}`).join('&')}`, {
          params: {
            merchantID: merchantId,
            takeaway,
          },
          retry: DEFAULT_RETRY_TIMES,
        }).then(res => res.data),
      ])
      const nonEmptyCategoryIds = flatten([nonEmptyMenuCategoryIds, nonEmptySetMenuCategoryIds])

      categories = categories.filter(category =>
        nonEmptyCategoryIds.includes(category.id) ||
        category.categories.filter(c => nonEmptyCategoryIds.includes(c.id)).length,
      )
      if (!takeaway) {
        categories = categories.filter(c => !c.takeawayOnly)
      }
      if (takeaway) {
        categories = categories.filter(c => !c.dineinOnly)
      }
      return categories
    })

    // res.data[0].steps[0].min = 0;
    // res.data[0].steps[1].min = 0;
    // res.data[0].steps[2].min = 1;

    // res.data[0].steps[0].max = 1;
    // res.data[0].steps[1].max = 1;
    // res.data[0].steps[2].max = 2;

    // res.data[2].steps[0].min = 1;
    // res.data[2].steps[1].min = 2;
    // res.data[2].steps[2].min = 2;

    return data
  },

  // > get all sets of this merchant
  async getSets (merchantId) {
    const res = await axios.get(`${baseUrl}/c/category?merchantID=${merchantId}&isSet=true`)
    return res.data
  },
}



// WEBPACK FOOTER //
// ./src/services/api/category.js